import { render } from "./AddOtherModal.vue?vue&type=template&id=3b1f6ef9&scoped=true"
import script from "./AddOtherModal.vue?vue&type=script&lang=js"
export * from "./AddOtherModal.vue?vue&type=script&lang=js"

import "./AddOtherModal.vue?vue&type=style&index=0&id=3b1f6ef9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1f6ef9"]])

export default __exports__